var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4995_34414)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "#0061FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8821 28.1052L41.4319 18.6543L32.5302 40.9387C35.0328 43.3691 40.0442 48.2794 40.069 48.4775C40.0938 48.6756 37.9848 52.7091 36.958 54.6235L27.9331 45.5986L24.8545 61.5618L19.1094 67.916L66.4749 115.282L108.278 72.9606L54.6138 19.2963H50.806L50.8821 28.1052Z",
    fill: "#004FCF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4995_34414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4283 47.1239C41.4283 46.2684 40.7281 45.5703 39.8747 45.5703H32.1069V51.7846C32.1069 52.928 31.1789 53.856 30.0354 53.856C28.892 53.856 27.964 52.928 27.964 51.7846V45.5703H20.1961C19.3406 45.5703 18.6426 46.2684 18.6426 47.1239V66.8025C18.6426 67.658 19.3406 68.356 20.1961 68.356H39.8747C40.7281 68.356 41.4283 67.658 41.4283 66.8025V47.1239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.357 47.1239C68.357 46.2684 67.6569 45.5703 66.8034 45.5703H59.0356V51.7846C59.0356 52.928 58.1076 53.856 56.9641 53.856C55.8207 53.856 54.8927 52.928 54.8927 51.7846V45.5703H47.1249C46.2694 45.5703 45.5713 46.2684 45.5713 47.1239V66.8025C45.5713 67.658 46.2694 68.356 47.1249 68.356H66.8034C67.6569 68.356 68.357 67.658 68.357 66.8025V47.1239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8922 20.1961C54.8922 19.3427 54.192 18.6426 53.3386 18.6426H45.5707V24.8569C45.5707 26.0003 44.6427 26.9283 43.4993 26.9283C42.3559 26.9283 41.4279 26.0003 41.4279 24.8569V18.6426H33.66C32.8045 18.6426 32.1064 19.3427 32.1064 20.1961V39.8747C32.1064 40.7302 32.8045 41.4283 33.66 41.4283H53.3386C54.192 41.4283 54.8922 40.7302 54.8922 39.8747V20.1961Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4995_34414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87,
    height: 87,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4995_34414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.7143,
    height: 49.7143,
    fill: "white",
    transform: "translate(18.6426 18.6426)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.087aa0323bccfd25b483ccce711ee5fa.svg";
export { ForwardRef as ReactComponent };